import { computed, reactive } from 'vue';
import { useQuery } from 'vue-query';
import { UseQueryOptions } from 'react-query/types';

import QUERY_KEYS from '@/constants/queryKeys';
import { balancerFarmSubgraphService } from '@/services/balancer/subgraph/balancer-farm-subgraph.service';
import { FarmUserInfo } from '@/services/balancer/subgraph/types';
import useNetwork from '../useNetwork';
import useWeb3 from '@/services/web3/useWeb3';

type FarmUserInfoResponse = FarmUserInfo[];

export default function useUserInfosQuery(
  _param: Record<string, string> = {},
  options: UseQueryOptions<FarmUserInfoResponse> = {}
) {
  // COMPOSABLES
  const { networkId } = useNetwork();
  const { account, isWalletReady } = useWeb3();

  /**
   * COMPUTED
   */
  const enabled = computed(() => isWalletReady.value && account.value != null);

  // DATA
  const queryKey = reactive(QUERY_KEYS.FarmPools.UserBasic(networkId, account));

  // METHODS
  const queryFn = async () => {
    return await balancerFarmSubgraphService.userInfos.get({
      where: Object.assign(
        {
          address: account.value.toLowerCase()
        },
        _param
      )
    });
  };

  const queryOptions = reactive({
    enabled,
    ...options
  });

  return useQuery<FarmUserInfoResponse>(queryKey, queryFn, queryOptions);
}
